"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/input/style/css");

var _input = _interopRequireDefault(require("antd/es/input"));

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

require("antd/es/list/style/css");

var _list = _interopRequireDefault(require("antd/es/list"));

require("antd/es/select/style/css");

var _select = _interopRequireDefault(require("antd/es/select"));

require("antd/es/form/style/css");

var _form = _interopRequireDefault(require("antd/es/form"));

var _react = _interopRequireWildcard(require("react"));

require("../activity.scss");

var _icons = require("@ant-design/icons");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  Item
} = _form.default;
const {
  Option
} = _select.default;

class ScreenerQuestionItem extends _react.Component {
  constructor() {
    super(...arguments);
    this.styles = {
      removeButton: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#f17878',
        borderColor: '#f17878',
        backgroundColor: '#FBDDDD',
        width: '32px',
        marginLeft: '10px'
      }
    };

    this.onTextChange = e => {
      const {
        question,
        updateQuestion
      } = this.props;
      question.text = e.target.value;
      updateQuestion(question);
    };

    this.onGroupChange = value => {
      const {
        question,
        updateQuestion
      } = this.props;
      question.optionGroupId = value;
      updateQuestion(question);
    };
  }

  render() {
    const {
      question,
      groups,
      disabled,
      removeQuestion
    } = this.props;
    const {
      text,
      optionGroupId,
      uuid
    } = question;
    return /*#__PURE__*/_react.default.createElement(_list.default.Item, {
      key: `question-list-item-${uuid}`,
      extra: /*#__PURE__*/_react.default.createElement(_button.default, {
        key: `remove-question-${uuid}`,
        disabled: disabled,
        style: this.styles.removeButton,
        onClick: removeQuestion,
        title: "Remove question"
      }, /*#__PURE__*/_react.default.createElement(_icons.CloseOutlined, null))
    }, /*#__PURE__*/_react.default.createElement(_list.default.Item.Meta, {
      title: /*#__PURE__*/_react.default.createElement(Item, {
        key: `question-text-${uuid}`,
        name: `question-text-${uuid}`,
        validateTrigger: ['onChange', 'onBlur', 'onFocus'],
        rules: [{
          required: true,
          message: 'Please input option text or delete this question.'
        }],
        initialValue: text
      }, /*#__PURE__*/_react.default.createElement(_input.default, {
        spellCheck: true,
        disabled: disabled,
        placeholder: "Question text",
        onChange: this.onTextChange
      })),
      description: /*#__PURE__*/_react.default.createElement(Item, {
        key: `select-optionGroupId-${uuid}`,
        name: `select-optionGroupId-${uuid}`,
        rules: [{
          required: true,
          message: 'Please select a group ID.'
        }],
        initialValue: optionGroupId
      }, /*#__PURE__*/_react.default.createElement(_select.default, {
        disabled: disabled,
        onChange: this.onGroupChange
      }, groups.map(([id, options]) => /*#__PURE__*/_react.default.createElement(Option, {
        key: `group-option-${id}`,
        value: id
      }, options.map(o => `${o.text} (${o.points})`).join(', ')))))
    }));
  }

}

var _default = ScreenerQuestionItem;
exports.default = _default;